var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view-box columns"},[(_vm.keepAlive)?_c('keep-alive',[_c('router-view')],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }